// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3M44k","label":"SetPasswdForm_label__1UDrb"};